// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapImage, BootstrapNav } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { ImageRatio } from '../_contracts';
import { prepareImage } from '../_filters/prepare-image';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let QuotesModuleUi = class QuotesModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Currently-active tab.
         */
        this.activeTab = '';
        /**
         * Tabs' content (resolved using `RelatedService`).
         */
        this.tabs = [];
        /**
         * @inheritDoc
         */
        this.imageRatios = {
            desktop: ImageRatio.Square,
            mobile: ImageRatio.Square
        };
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        try {
            await this.composeTabs();
        }
        catch (e) {
            this.onError(e);
        }
        if (this.tabs.length > 0) {
            this.activeTab = this.tabs[0].id;
            this.onReady();
        }
        else {
            this.onError();
        }
    }
    /**
     * Determines whether the author of the passed-in quote has its image defined.
     *
     * @param quote - The quote to check.
     */
    hasAuthorImage(quote) {
        return typeof quote !== 'undefined' &&
            typeof quote.author !== 'undefined' &&
            typeof quote.author.image !== 'undefined' &&
            quote.author.image !== null;
    }
    /**
     * Composes the tabs array.
     */
    async composeTabs() {
        const tabsToResolve = Array.isArray(this.module.content.tabs) ? this.module.content.tabs : [];
        await Promise.all(tabsToResolve.map((rawTab, index) => {
            return new Promise((resolve) => {
                this.resolveSingleTab(rawTab, index)
                    .catch(e => {
                    if (this.debug)
                        console.warn(e);
                })
                    .finally(() => {
                    resolve();
                });
            });
        }));
    }
    /**
     * Resolves all related data for the passed-in tab.
     *
     * @param rawTab - The tab which content is to be resolved.
     * @param index - Tab's index in `this.tabs` array.
     */
    async resolveSingleTab(rawTab, index) {
        const { intro, label, text, quote } = rawTab;
        const tab = {
            disabled: false,
            id: `${label}-${index}`,
            intro,
            label,
            quote: {
                ...quote,
                author: {
                    ...quote.author,
                    image: null
                }
            },
            text
        };
        if (quote.author.image !== null) {
            let imageFile = null;
            try {
                imageFile = await this.relatedService.resolve(quote.author.image);
            }
            catch (e) {
                console.warn(e);
            }
            if (imageFile !== null && imageFile.url) {
                tab.quote.author.image = prepareImage(imageFile, this.imageRatio, 72, this.module.isLazyLoaded);
            }
        }
        this.tabs = [...this.tabs, tab];
    }
};
QuotesModuleUi = __decorate([
    Component({
        name: 'QuotesModuleUi',
        components: { BootstrapImage, BootstrapNav },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="quotes-module defence-ads" :style="{ background }">
      <template v-if="tabs && tabs.length">

        <!-- Tabs / Nav -->
        <BootstrapNav :activeItem.sync="activeTab" :items="tabs"
                      class="quotes-module__nav" />

        <!-- Tabs / Content -->
        <div v-for="tab in tabs" :key="tab.id" v-show="activeTab === tab.id"
             class="quotes-module__tab">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10">

                <!-- Intro -->
                <p v-if="tab.intro" v-html="tab.intro" class="quotes-module__tab__intro" />

                <!-- Text -->
                <p v-if="tab.text" v-html="tab.text" class="quotes-module__tab__text" />

                <!-- Quote -->
                <blockquote v-if="tab.quote && tab.quote.text" class="quotes-module__tab__quote quote"
                            :class="{ '--with-image': hasAuthorImage(tab.quote) }">
                  <!-- Text -->
                  <p v-html="tab.quote.text" class="quote__text" />

                  <!-- Author -->
                  <cite v-if="tab.quote.author" class="quote__author">
                    <BootstrapImage v-if="hasAuthorImage(tab.quote)" v-bind="tab.quote.author.image"
                                    class="quote__author__image" />
                    <span v-if="tab.quote.author.name" v-html="tab.quote.author.name"
                          class="quote__author__name" />
                    <small v-if="tab.quote.author.role" v-html="tab.quote.author.role"
                           class="quote__author__role" />
                  </cite>
                </blockquote>
                <!-- END | Quote -->

              </div>
            </div>
          </div>
        </div>
        <!-- END | Tabs / Content -->

      </template>
    </section>
  `
    })
], QuotesModuleUi);
export { QuotesModuleUi };
